<form name="remittanceRemarksForm" novalidate>
  <div class="row">
    <div class="col-xs-12">
      <h4>Remittance Remarks:</h4>
    </div>

    <div class="col-xs-12">
      <app-grid-wrapper #selectedRarCodeList [gridSize]="GridSize.xsmall" [autoHeight]="false">
        <button
          class="btn btn-primary"
          (click)="showAddModal()"
          [disabled]="!canAddRarCode() || !canEditRemittanceRemarks()"
        >
          <i class="fa fa-plus"></i> Add
        </button>
      </app-grid-wrapper>
    </div>
  </div>
</form>
